import React from "react";
import { formatAdminAuditTimestamp } from "../../utils/adminAudit";
import { buildAuditPanelState } from "../../utils/auditHelpers";

const RecordAuditPanel = ({ auditMetadata, canEdit }) => {
  const {
    lastEditedBy,
    lastEditedAt,
    lastReviewedBy,
    lastReviewedAt,
    changedFields,
    shouldShowLastEditedBy,
    shouldShowLastEditedAt,
    shouldShowLastReviewedBy,
    shouldShowLastReviewedAt,
    shouldShowChangedFields,
    hasEditAudit,
  } = buildAuditPanelState(auditMetadata);

  if (!canEdit || !hasEditAudit) {
    return null;
  }

  const formattedLastEditedAt = formatAdminAuditTimestamp(lastEditedAt);
  const shouldShowAuditMetadata =
    shouldShowLastEditedBy ||
    shouldShowLastEditedAt ||
    shouldShowLastReviewedBy ||
    shouldShowLastReviewedAt ||
    shouldShowChangedFields;

  if (!shouldShowAuditMetadata) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-amber-400/20 bg-amber-500/10 px-4 py-4  mb-3">
      <h3 className="text-[11px] font-semibold uppercase tracking-[0.22em] text-amber-100/85 mb-3">
        Last Edited
      </h3>
      <div className="mt-3 space-y-2 text-sm text-slate-100">
        {shouldShowLastEditedBy ? (
          <p>
            <span className="font-medium text-slate-300">Last edited by:</span>{" "}
            <span>{lastEditedBy}</span>
          </p>
        ) : null}
        {shouldShowLastEditedAt ? (
          <p>
            <span className="font-medium text-slate-300">Last edited at:</span>{" "}
            <span>{formattedLastEditedAt}</span>
          </p>
        ) : null}
        {shouldShowLastReviewedBy ? (
          <p>
            <span className="font-medium text-slate-300">Last reviewed by:</span>{" "}
            <span>{lastReviewedBy}</span>
          </p>
        ) : null}
        {shouldShowLastReviewedAt ? (
          <p>
            <span className="font-medium text-slate-300">Last reviewed at:</span>{" "}
            <span>{formatAdminAuditTimestamp(lastReviewedAt)}</span>
          </p>
        ) : null}
        {shouldShowChangedFields ? (
          <p>
            <span className="font-medium text-slate-300">Changed fields:</span>{" "}
            <span>{changedFields.join(", ")}</span>
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default RecordAuditPanel;
